import { Inject, Injectable } from "@angular/core";
import { COMON_WEB_API } from "../tokens";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IPostLikeInformation } from "projects/models/src/public-api";

@Injectable({
  providedIn: 'root'
})
export class PostLikeService {

  constructor(@Inject(COMON_WEB_API) private api: string, private http: HttpClient) { }

  public like(postId: number): Observable<void> {
    return this.http.post<void>(`${this.api}/likes/${postId}`, {});
  }

  public unlike(postId: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/likes/${postId}`, {});
  }

  public getInformation(postId): Observable<IPostLikeInformation> {
    return this.http.get<IPostLikeInformation>(`${this.api}/likes/${postId}`);
  }

}
